import axios from 'axios';

const clienteAxios = axios.create({
     //baseURL : "http://localhost:5002"
    baseURL : "https://mariajuana.dyndns.org:5050"
    //baseURL: "http://cloudvps.com.ar:5230"
});
/*  clienteAxios.interceptors.response.use((response) => {
    return response
  }, async function (error) {
    if (error.response.status === 401 ) {
        delete clienteAxios.defaults.headers.common['Authorization'];        
    }
    return Promise.reject(error);
  });  */
export default clienteAxios;